export default __webpack_public_path__ + "static/media/OAngry.b9111952.svg";